import React, { Component } from "react";
import ArchiveTracksContainer from "./ArchiveTracksContainer";

import "./ArchivePage.less";

// const classNames = require("classnames");

class ArchivePage extends Component {
  state = {
    page: 0,
  };
  render() {
    return (
      <React.Fragment>
        <div className="page-header">
          <h1>Archive</h1>
          <p>
            Scroll down the chimney and catch up on previous tracks of the day. If you prefer, theres also the{" "}
            <a href="//www.dreamchimney.com/tracks/instatracks/#/" target="_blank" rel="noopener noreferrer">
              the Instagram styled version
            </a>
            .
          </p>
        </div>
        <ArchiveTracksContainer render={(items) => items} />
      </React.Fragment>
    );
  }
}

export default ArchivePage;
